import React, { ReactNode } from 'react';
import { Tooltip } from '@kontentino/ui';

interface InstagramAudioDisabledTooltipProps {
  reason?: string | null;
  children: ReactNode;
}

/** Disabled buttons fire no hover events, so the wrapper carries the tooltip. */
const InstagramAudioDisabledTooltip = ({
  reason,
  children,
}: InstagramAudioDisabledTooltipProps) => (
  <Tooltip content={reason ?? undefined}>
    <span className="tw-inline-flex">{children}</span>
  </Tooltip>
);

export default InstagramAudioDisabledTooltip;
